module.exports = __webpack_public_path__ + "img/turn_face_right.30b4f8a0.svg";